export default __webpack_public_path__ + "static/media/sample2.518246c0.mp4";